module.exports = __webpack_public_path__ + "static/img/tl1838-1.a3b3dde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tl1838-1.svg
// module id = MyUY
// module chunks = 0